import React, { useContext } from "react";
import EscapeRoomTile from "./components/EscapeRoomTile";
import escapeDataImport from "./components/EscapeRoomData";
import "./EscapeRooms.css";
import { Helmet } from "react-helmet";
import { AppContext } from "../shared/context/AppContext";

function EscapeRooms() {
  const { dotcom, language } = useContext(AppContext);
  const nl = language === "NL";

  // The .com site only lists the English rooms. Copy before sorting so the
  // shared data keeps its order.
  const escapeData = dotcom
    ? escapeDataImport.filter((escaperoom) => escaperoom.english === true)
    : [...escapeDataImport].sort((a, b) => (a.order > b.order ? 1 : -1));

  const escapeRoomTiles = escapeData.map((ER) => (
    <EscapeRoomTile
      key={ER.id}
      title={ER.title}
      titleEN={ER.titleEN}
      estTime={ER.estTime}
      price={ER.price}
      linkto={ER.linkto}
      live={ER.live}
      gifName={ER.gifName}
      picName={ER.picName}
      dutch={ER.dutch}
      english={ER.english}
    />
  ));

  return (
    <main className="page">
      <Helmet>
        <title>
          {nl
            ? "Alle escape rooms | Escape Mystery"
            : "All escape rooms | Escape Mystery"}
        </title>
      </Helmet>
      <section className="light-bg">
        <div className="page-intro">
          <h1>Online escape rooms</h1>
          <p>
            {nl
              ? "Loop rond in echte 360° omgevingen en kraak samen de puzzels. Speel thuis, met vrienden, familie of collega's."
              : "Walk around real 360° locations and crack the puzzles together. Play from home, with friends, family or colleagues."}
          </p>
        </div>
        <ul className="page-content" id="escaperoom-tiles">
          {escapeRoomTiles}
        </ul>
      </section>
    </main>
  );
}

export default EscapeRooms;
